import { Select } from 'src/components/Antd/Select';
import React from 'react';
import { Form } from 'src/components/Antd';
import { generalFilterOptions } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { Icon } from '@/src/tools/icon';
import css from './css.module.less';

const Item = Form.Item;
const Option = Select.Option;

const Language = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { noStyle, name, rules, options, disabled } = props;

  return (
    <Item
      noStyle={noStyle}
      name={name}
      rules={
        rules ||
        [
          // {
          //   required: true,
          //   message: 'Please select at least one sales channel',
          // },
        ]
      }>
      <Select
        disabled={disabled}
        mode='multiple'
        size='large'
        filterOption={generalFilterOptions}
        showArrow
        selectClassName={css.select}
        suffixIcon={<Icon type='iconsearch' />}
        showSearch
        placeholder={getI18n('general.advancedFilters.language.placeholder')}
        //open={true}
        // getPopupContainer={() => document.body}
      >
        {(options || []).map((i) => {
          const { label, value } = i;
          return (
            <Option value={value} key={value}>
              {label}
            </Option>
          );
        })}
      </Select>
    </Item>
  );
};
export default Language;
